import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { bookingRecordQuery } from "@/app/Bookings/GraphQL/bookingRecordQuery";

export function useBooking(id: string) {
  const { data } = useSuspenseGqlQuery(bookingRecordQuery, {
    id,
  });

  return data.booking;
}
